import PropTypes from 'prop-types'

function EmptyState({ icon, title, description, action, className = '' }) {
  return (
    <div className={`text-center py-12 ${className}`}>
      <div className="mx-auto w-16 h-16 bg-neutral-100 dark:bg-neutral-800 rounded-full flex items-center justify-center mb-4">
        <div className="text-neutral-400 dark:text-neutral-500 text-2xl">{icon}</div>
      </div>
      <h3 className="text-lg font-medium text-neutral-900 dark:text-white mb-2">{title}</h3>
      <p className="text-neutral-600 dark:text-neutral-400 mb-6 max-w-md mx-auto">{description}</p>
      {action && <div className="flex justify-center">{action}</div>}
    </div>
  )
}

EmptyState.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.node,
  className: PropTypes.string,
}

export default EmptyState
